import typography from "Config/typography"
import Config from "Data"

export const BrandColor = (name) => {
  switch (name) {
    case "cxosync":
      return Config.brandsColors.cxosync
    case "ciosynergy":
      return Config.brandsColors.ciosynergy
    case "fintechcio":
      return Config.brandsColors.fintechcio
    case "ciohealth":
      return Config.brandsColors.ciohealth
    case "secureciso":
      return Config.brandsColors.secureciso
    case "fintechciso":
      return Config.brandsColors.fintechciso
    case "cfo.org":
      return Config.brandsColors.cfoorg
    case "cmo.org":
      return Config.brandsColors.cmoorg
    case "merchant.org":
      return Config.brandsColors.merchantorg
    case "hr":
      return Config.brandsColors.hr
    case "cx":
      return Config.brandsColors.cx
    case "eps":
      return Config.brandsColors.eps
    case "cxosports":
      return Config.brandsColors.cxosports
    case "cxostories":
      return Config.brandsColors.cxostories
    case "panels":
      return Config.brandsColors.panels
    case "notice":
      return Config.brandsColors.notice
    case "white":
      return Config.brandsColors.white
    default:
      return Config.brandsColors.default
  }
}

export const colors = {
  white: {
    base: "#fff",
    light: "#f5f5f5",
    grey: "#cecece",
    dark: "#a0afd7",
  },
  red: {
    base: "#dc0000",
  },
  black: {
    base: "#333438",
    light: "#4b4e57",
    grey: "#ddd",
    blue: "#2e3246",
  },
  primary: {
    base: BrandColor(Config.brand.toLowerCase()),
    light: BrandColor(Config.brand.toLowerCase()),
    dark: BrandColor(Config.brand.toLowerCase()),
  },
  background: {
    light: "#f1f2f3",
    dark: "#171717",
    black: "#000000",
    white: "#ffffff",
  },
  body: {
    color: "#171717",
    background: "#fff",
  },
  gradient: {
    light: "rgba(0, 0, 0, 0.5)",
    dark: "rgba(0, 0, 0, 0.7)",
  },
  gradientLight: {
    light: "rgba(0, 0, 0, 0.2)",
    dark: "rgba(0, 0, 0, 1)",
  },
}

export const shadow = {
  event: "0 12px 46px 0 rgba(0,0,0,0.4)",
  image: "0 12px 46px -18px rgba(0,0,0,0.4)",
  suggestion: "0 -5px 30px rgba(0,0,0,0.4)",
  footer: "0 -3px 26px rgba(0,0,0,0.5)",
  feature: {
    big: {
      default: "0 12px 46px -18px rgba(0,0,0,0.4)",
      hover: "0 50px 50px rgba(0, 0, 0, 0.4)",
    },
    small: {
      default: "0 12px 46px -18px rgba(0,0,0,0.4)",
      hover: "0 6px 12px rgba(0,0,0,0.4)",
    },
  },
  text: {
    small: "0 5px 10px rgba(0, 0, 0, 0.4)",
    big: "0 15px 20px rgba(0, 0, 0, 0.4)",
  },
}

export const gradient = {
  // eslint-disable-next-line
  leftToRight: `linear-gradient(-45deg, ${colors.gradient.light} 0%, ${colors.gradient.dark} 100%)`,
  // eslint-disable-next-line
  rightToLeft: `linear-gradient(45deg, ${colors.gradient.light} 0%, ${colors.gradient.dark} 100%)`,
  // eslint-disable-next-line
  topToBottom: `linear-gradient(180deg, ${colors.gradient.light} 70%, ${colors.gradient.dark} 100%)`,
  // eslint-disable-next-line
  bottomToTop: `linear-gradient(0deg, ${colors.gradient.dark} 0%, ${colors.gradient.light} 100%)`,
  bottomToTopLight: `linear-gradient(0deg, ${colors.gradientLight.light} 0%, ${colors.gradientLight.dark} 100%)`,
}

export const transition = {
  easeInOutCubic: "cubic-bezier(0.645, 0.045, 0.355, 1)",
  easeOutBack: "cubic-bezier(0.175, 0.885, 0.32, 1.275)",
  duration: "0.3s",
}

export const theme = {
  colors,
  gradient,
  shadow,
  fontSize: {
    xsmall: "10px",
    smallish: "12px",
    small: "14px",
    medium: "16px",
    large: "18px",
    xlarge: "20px",
    xxlarge: "22px",
    h7 : "1.4em",
    h6: "1em",
    h5: "1.6em",
    h4: "1.8em",
    h3: "2em",
    h2: "2.4em",
    h1: "2.8em",
    hero: "3em",
  },

  easing: "cubic-bezier(0.645, 0.045, 0.355, 1)",

  headerHeight: 80,
  headerScrollHeight: "80px",
  margin: "1rem",
  padding: "1rem",
  tabHeight: 60,
  tabWidth: 120,

  hamburgerWidth: 30,
  hamBefore: `top 0.1s ease-in 0.25s, opacity 0.1s ease-in`,
  hamBeforeActive: `top 0.1s ease-out, opacity 0.1s ease-out 0.12s`,
  hamAfter: `bottom 0.1s ease-in 0.25s, transform 0.22s cubic-bezier(0.55, 0.055, 0.675, 0.19)`,
  hamAfterActive: `bottom 0.1s ease-out, transform 0.22s cubic-bezier(0.215, 0.61, 0.355, 1) 0.12s`,

  breakpoints: {
    xs: "400px",
    s: "600px",
    m: "900px",
    l: "1240px",
    xl: "1400px",
  },
  fontFamily: {
    // eslint-disable-next-line
    body: typography.bodyFontFamily,
    // eslint-disable-next-line
    heading: typography.headerFontFamily,
    qoute: `'sans-serif', 'Open Sans', 'Arial', '-apple-system', 'BlinkMacSystemFont', 'Segoe UI', 'Roboto', 'Helvetica'`,
  },
  layout: {
    blog: "800px",
    base: "1240px",
    big: "1400px",
  },
  elementRadius: "6",
  borderRadius: {
    elements: "3px",
    ui: "6px",
    round: "999px",
  },
  transitions: {
    default: {
      duration: transition.duration,
      timing: transition.easeInOutCubic,
      transition: `all ${transition.duration} ${transition.easeInOutCubic}`,
    },
    boom: {
      duration: transition.duration,
      timing: transition.easeOutBack,
      transition: `all ${transition.duration} ${transition.easeOutBack}`,
    },
  },
}
